import Store from 'core/Store'

function MobileNav ($, $button, $main) {
  let active = false
  Store.watch('size', onResize)
  Store.watch('env', onEnvChange)
  $button.addEventListener('click', toggle)

  function toggle () {
    if (active) close()
    else open()
  }

  function open () {
    document.body.classList.add('menu-visible')
    $button.classList.add('active')
    $.classList.add('active')
    $main.classList.add('hidden')
    active = true
  }

  function close () {
    document.body.classList.remove('menu-visible')
    $button.classList.remove('active')
    $.classList.remove('active')
    $main.classList.remove('hidden')
    active = false
  }

  function onEnvChange () {
    if (active) close()
  }

  function onResize (nSize) {
    if (nSize.w > Store.get('breakpoint.desktop') && active) close()
  }
}

export default MobileNav



// WEBPACK FOOTER //
// ./src/js/components/MobileNav.js